import React, {createContext, useContext} from 'react';
import {QueueContextProviderValue} from './types';
import {useQueue} from '../../hooks';

interface QueueContextProviderProps {
  children: React.ReactNode;
}

const QueueContextObject = createContext<QueueContextProviderValue | null>(
  null,
);

export default function QueueProvider({children}: QueueContextProviderProps) {
  const queue = useQueue();

  return (
    <QueueContextObject.Provider value={queue}>
      {children}
    </QueueContextObject.Provider>
  );
}

// Use to consume the context. Exists for type safety with useContext
export function useQueueContext() {
  const queueContext = useContext(QueueContextObject);
  if (!queueContext) {
    // Removes need for non-null assertion
    throw new Error(
      'QueueContext: Tried to use context without providing a value',
    );
  }
  return queueContext;
}
